module.exports = __webpack_public_path__ + "img/yellow-boat.c8d237b3.jpg";